//#region Function Imports
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { FlatList, StyleSheet, Platform, SafeAreaView, View, useWindowDimensions, ActivityIndicator } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from '../../../styles/commonStyles';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../components/CustomInput/CustomInput';
import CustomButton from '../../../components/CustomButton/CustomButton';
import CustomDropDown from '../../../components/CustomDropDown/CustomDropdown';
import CustomMultiSelectDropdown from '../../../components/CustomMultiSelectDropdown/CustomMultiSelectDropdown';
import { useTimeSheets } from '../../../hooks/useTimeSheets';
import { Card } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import { useTableHelper } from '../../../hooks/useTableHelper';
import { showMessage } from "react-native-flash-message";
import { changeDateFromDDMMYYYYtoYYYYMMDD, getMonthFromDDMMYYYY } from '../../../constants/FormatDate';
import Swal from 'sweetalert2';
//#endregion

const FlatListView = React.memo(({ item, index, props, styles, setVal, duplicates,
    removeTimesheetLine, t, periodDayTime, additionalPeriods, additionalPeriodsValue, employees, setEmployeeVal }) => {
    let errorMark = false;
    let errorAttr = '';
    duplicates.forEach(duplicate => {
        if (duplicate.attrVal.toLowerCase().includes(item[duplicate.attribute].toLowerCase())) {
            errorMark = true;
            errorAttr = duplicate.attribute;
        }
    });

    // * For Totals 
    const [total, setTotal] = useState(0);

    useEffect(() => {
        calculateTotal()
        // * No Additional Periods on Afternoon periods PM 
        if (item.ptshdt === 'PM' && item.additionalCode === '') {
            setVal(index, item, 'additionalCode', ['NO'])
        }
    }, [item])

    const convertPeriodsToUnits = (convertAdditional = false) => {
        let yA = GetYearAverage();
        let aT = convertAdditional ? calcAdditionalTotal() : 0;
        let finalTotal = yA + aT;
     
        if (props.selectedItem.branch === 'PSS' || props.selectedItem.branch === 'NIC')
            finalTotal = convert40to45(finalTotal);

        if (item.oAverage > 0)
            finalTotal = item.oAverage
        if (finalTotal <= 4) {
            finalTotal = 0;
        }
        else if (finalTotal >= 5 && finalTotal <= 10) {
            finalTotal = '1/3';
        }
        else if (finalTotal >= 5 && finalTotal <= 18) {
            finalTotal = '2/3';
        }
        else if (finalTotal >= 19) {
            finalTotal = '3/3';
        }

        return finalTotal
    }
    const calcAdditionalTotal = (convertUnit = false) => {
        let oTotal = 0;
        if (item.additionalCode === '')
            return oTotal;

        item.additionalCode?.forEach(function (code) {
            oTotal += additionalPeriodsValue.find(app => app.additionalCode === code)?.periodDuration ?? 0;
        });
        if (!convertUnit)
            return oTotal
    }

    const convert40to45 = (total) => {
        return ((total * 40) / 45).toFixed(1);
    }

    const GetYearAverage = () => {
        return parseInt(item.mAverage) !== 0 ? item.mAverage : (
            parseInt(item.m1, 10) +
            parseInt(item.m2, 10) +
            parseInt(item.m3, 10) +
            parseInt(item.m4, 10) +
            parseInt(item.m5, 10) +
            parseInt(item.m6, 10) +
            parseInt(item.m7, 10) +
            parseInt(item.m8, 10) +
            parseInt(item.m9, 10) +
            parseInt(item.m10, 10)) / 10;
    }

    const calculateTotal = () => {
        let aTotal = GetYearAverage();
        let oTotal = calcAdditionalTotal();

        if (props.selectedItem.branch === 'PSS' || props.selectedItem.branch === 'NIC')
            aTotal = convert40to45(aTotal)
        if (parseInt(item.mAverage) === 0 && parseInt(item.oAverage) === 0) {
            setTotal(parseFloat(aTotal) + parseFloat(oTotal));
        } else if (parseInt(item.mAverage) === 0 && parseInt(item.oAverage) !== 0) {
            setTotal(parseFloat(aTotal) + parseInt(item.oAverage));
        }
        else if (parseInt(item.mAverage) !== 0 && parseInt(item.oAverage) === 0) {
            setTotal(parseInt(item.mAverage) + oTotal);
        } else if (parseInt(item.mAverage) !== 0 && parseInt(item.oAverage) !== 0) {
            setTotal(parseInt(item.mAverage) + parseInt(item.oAverage));
        }
    };
    return (
        <SafeAreaView style={styles.item}>
            {/* Main Line*/}
            <SafeAreaView
                style={styles.row}>
                <CustomDropDown
                    options={employees}
                    disabled={props.selectedItem.submitted}
                    defValue={item.employeeID}
                    value={item.employeeID}
                    setValue={(value) => setEmployeeVal(index, item, 'employeeID', value)}
                    type='FULL'
                />

                <CustomDropDown
                    options={periodDayTime}
                    disabled={props.selectedItem.submitted}
                    defValue={item.ptshdt}
                    value={item.ptshdt}
                    setValue={(value) => setVal(index, item, 'ptshdt', value)}
                    type='FULL'
                />

                {!props.selectedItem.submitted &&
                    <CustomButton
                        onPress={() => {
                            removeTimesheetLine(index, item)
                        }}
                        iconName='trash-outline'
                        disabled={props.selectedItem.submitted}
                        show='TIMESHEET'
                        type='TIMESHEET'
                        textTop='0'
                        sz={30}
                    />
                }
            </SafeAreaView>
            {(props.selectedItem.branch === 'PSS' || props.selectedItem.branch === 'NIC') && item.ptshdt !== 'PM' &&
                <SafeAreaView style={styles.item}>
                    <CustomMultiSelectDropdown
                        items={additionalPeriods}
                        disabled={props.selectedItem.submitted || item.ptshdt === 'PM'}
                        selectedItems={item.additionalCode}
                        onSelectedItemsChange={(value) => setVal(index, item, 'additionalCode', value)}
                    />
                </SafeAreaView>}
            <View style={styles.lineInvisible} />
            {/* upper row */}
            {(item.employeeID !== '' && item.ptshdt !== '' && item.additionalCode !== '') &&
                <SafeAreaView
                    style={styles.row}>
                    <SafeAreaView
                        style={styles.row25}>
                        <CustomLabel
                            value={item.employeeID}
                            type='TIMESHEET' />
                        <CustomLabel
                            value={item.emplNumber === '' ? item.passNumber : item.emplNumber}
                            type='TIMESHEET' />
                        {item.passNumber !== '' && <CustomLabel
                            value={item.passNumber}
                            type='TIMESHEET' />
                        }
                        <CustomLabel
                            value={item.jobTitle}
                            type='TIMESHEET_WIDER' />
                        <CustomLabel
                            value={item.school}
                            type='TIMESHEET_WIDER' />
                        {item.jobTitle !== item.seniority && <CustomLabel
                            value={item.seniority}
                            type='TIMESHEET_WIDER' />}
                        <CustomLabel
                            value={item.actualStartDate ? item.actualStartDate : item.startDate}
                            type='TIMESHEET'
                        />
                        <CustomLabel
                            value={' - '}
                            type='TIMESHEET' />
                        <CustomLabel
                            value={item.endDate === '' ? 'No end date' : item.endDate}
                            type='TIMESHEET' />
                        {/* //* ignore default employment context - eventualy no employee will have default but as of 05052025 this is not the case  */}
                        {item.employmentContext !== 'Def' && <CustomLabel
                            value={item.emplContextDesc}
                            type='TIMESHEET' />}
                    </SafeAreaView>
                </SafeAreaView>
            }
            <View style={styles.lineInvisible} />
            {/* comments and time */}
            {(item.employeeID !== '' && item.ptshdt !== '' && item.additionalCode !== '') &&
                <SafeAreaView
                    style={styles.row}>
                    <SafeAreaView style={styles.detailsRowComments}>
                        <SafeAreaView style={styles.details}>
                            <CustomInput
                                type={'MAININPUT'}
                                value={item.comments}
                                editable={!props.selectedItem.submitted}
                                multiline={true}
                                numberOfLines={5}
                                selectall={!props.selectedItem.submitted}
                                setValue={(value) => setVal(index, item, 'comments', value)}
                            />
                        </SafeAreaView>
                    </SafeAreaView>
                    <SafeAreaView style={styles.detailsRowHours}>
                        <SafeAreaView
                            style={styles.details}>
                            <SafeAreaView
                                style={styles.rowMonths}>
                                <SafeAreaView style={styles.months}>
                                    <CustomLabel
                                        value={t('common:m1')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={item.m1}
                                        selectall={!props.selectedItem.submitted}
                                        setValue={(value) => setVal(index, item, 'm1', value === '' ? 0 : value, item.startDate)}
                                    />
                                </SafeAreaView>
                                <SafeAreaView style={styles.months}>
                                    <CustomLabel
                                        value={t('common:m2')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={item.m2}
                                        selectall={!props.selectedItem.submitted}
                                        setValue={(value) => setVal(index, item, 'm2', value === '' ? 0 : value, item.startDate)}
                                    />
                                </SafeAreaView>
                                <SafeAreaView style={styles.months}>
                                    <CustomLabel
                                        value={t('common:m3')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={item.m3}
                                        selectall={!props.selectedItem.submitted}
                                        setValue={(value) => setVal(index, item, 'm3', value === '' ? 0 : value, item.startDate)}
                                    />
                                </SafeAreaView>
                                <SafeAreaView style={styles.months}>
                                    <CustomLabel
                                        value={t('common:m4')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={item.m4}
                                        selectall={!props.selectedItem.submitted}
                                        setValue={(value) => setVal(index, item, 'm4', value === '' ? 0 : value, item.startDate)}
                                    />
                                </SafeAreaView>
                                <SafeAreaView style={styles.months}>
                                    <CustomLabel
                                        value={t('common:m5')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={item.m5}
                                        selectall={!props.selectedItem.submitted}
                                        setValue={(value) => setVal(index, item, 'm5', value === '' ? 0 : value, item.startDate)}
                                    />
                                </SafeAreaView>
                                <SafeAreaView style={styles.months}>
                                    <CustomLabel
                                        value={t('common:m6')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={item.m6}
                                        selectall={!props.selectedItem.submitted}
                                        setValue={(value) => setVal(index, item, 'm6', value === '' ? 0 : value, item.startDate)}
                                    />
                                </SafeAreaView>
                            </SafeAreaView>
                            <SafeAreaView
                                style={styles.rowMonths}>
                                <SafeAreaView style={styles.months}>
                                    <CustomLabel
                                        value={t('common:m7')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={item.m7}
                                        selectall={!props.selectedItem.submitted}
                                        setValue={(value) => setVal(index, item, 'm7', value === '' ? 0 : value, item.startDate)}
                                    />
                                </SafeAreaView>
                                <SafeAreaView style={styles.months}>
                                    <CustomLabel
                                        value={t('common:m8')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={item.m8}
                                        selectall={!props.selectedItem.submitted}
                                        setValue={(value) => setVal(index, item, 'm8', value === '' ? 0 : value, item.startDate)}
                                    />
                                </SafeAreaView>
                                <SafeAreaView style={styles.months}>
                                    <CustomLabel
                                        value={t('common:m9')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={item.m9}
                                        selectall={!props.selectedItem.submitted}
                                        setValue={(value) => setVal(index, item, 'm9', value === '' ? 0 : value, item.startDate)}
                                    />
                                </SafeAreaView>
                                <SafeAreaView style={styles.months}>
                                    <CustomLabel
                                        value={t('common:m10')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={item.m10}
                                        selectall={!props.selectedItem.submitted}
                                        setValue={(value) => setVal(index, item, 'm10', value === '' ? 0 : value, item.startDate)}
                                    />
                                </SafeAreaView>
                                <SafeAreaView style={styles.months}>
                                    <CustomLabel
                                        value={t('common:m11')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={item.m11}
                                        selectall={!props.selectedItem.submitted}
                                        setValue={(value) => setVal(index, item, 'm11', value === '' ? 0 : value, item.startDate)}
                                    />
                                </SafeAreaView>
                                <SafeAreaView style={styles.months}>
                                    <CustomLabel
                                        value={t('common:m12')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={item.m12}
                                        selectall={!props.selectedItem.submitted}
                                        setValue={(value) => setVal(index, item, 'm12', value === '' ? 0 : value, item.startDate)}
                                    />
                                </SafeAreaView>
                            </SafeAreaView>
                            <SafeAreaView style={styles.averageRow}>
                                <SafeAreaView style={styles.average}>
                                    <CustomLabel
                                        value={t('common:average')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={GetYearAverage()}
                                        selectall={!props.selectedItem.submitted}
                                        setValue={(value) => setVal(index, item, 'mAverage', value === '' ? 0 : value, item.startDate)}
                                    />
                                </SafeAreaView>
                                {(props.selectedItem.branch === 'PSS' || props.selectedItem.branch === 'NIC') && item.ptshdt !== 'PM' &&
                                    <SafeAreaView style={styles.average}>
                                        <CustomLabel
                                            value={t('common:45Min')}
                                            type='TIMESHEET' />
                                        <CustomInput
                                            type='SMALLSQUARE'
                                            editable={!props.selectedItem.submitted}
                                            value={convert40to45(GetYearAverage())}
                                            selectall={!props.selectedItem.submitted}
                                        />
                                    </SafeAreaView>
                                }

                                <SafeAreaView style={styles.average}>
                                    <CustomLabel
                                        value={t('common:unitConvert')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={!props.selectedItem.submitted}
                                        value={convertPeriodsToUnits()}
                                        selectall={!props.selectedItem.submitted}
                                    />
                                </SafeAreaView>

                                {(props.selectedItem.branch === 'PSS' || props.selectedItem.branch === 'NIC') && item.ptshdt !== 'PM' &&
                                    <SafeAreaView style={styles.average}>
                                        <CustomLabel
                                            value={t('common:averageAdditional')}
                                            type='TIMESHEET' />
                                        <CustomInput
                                            type='SMALLSQUARE'
                                            editable={!props.selectedItem.submitted}
                                            value={parseInt(item.oAverage) !== 0 ? item.oAverage : isNaN(calcAdditionalTotal()) ? 0 : calcAdditionalTotal()}
                                            selectall={!props.selectedItem.submitted}
                                            setValue={(value) => setVal(index, item, 'oAverage', value === '' ? 0 : value, item.startDate)}
                                        />

                                    </SafeAreaView>

                                }
                                <SafeAreaView style={styles.average}>
                                    <CustomLabel
                                        value={t('common:Total')}
                                        type='TIMESHEET' />
                                    <CustomInput
                                        type='SMALLSQUARE'
                                        editable={false}
                                        value={isNaN(Number.parseFloat(total).toFixed(1)) ? 0 : Number.parseFloat(total).toFixed(1)}
                                        selectall={!props.selectedItem.submitted}
                                    />
                                </SafeAreaView>
                                {(props.selectedItem.branch === 'PSS' || props.selectedItem.branch === 'NIC') && item.ptshdt !== 'PM' &&
                                    <SafeAreaView style={styles.average}>
                                        <CustomLabel
                                            value={t('common:Total')}
                                            type='TIMESHEET' />
                                        <CustomInput
                                            type='SMALLSQUARE'
                                            editable={!props.selectedItem.submitted}
                                            value={convertPeriodsToUnits(true)}
                                            selectall={!props.selectedItem.submitted}
                                        />
                                    </SafeAreaView>

                                }
                            </SafeAreaView>
                        </SafeAreaView>
                    </SafeAreaView>
                </SafeAreaView>
            }
        </SafeAreaView >
    )

})

const TeacherPeriods = (props) => {

    //#region Function Consts
    const { t } = useTranslation();
    const { width, height } = useWindowDimensions()
    const { colors } = useTheme();
    const common = createCommonStyles(colors);
    const styles = makeStyles(colors, height, width);
    const [loading, setLoading] = useState(false);
    const [teacherPeriods, setTeacherPeriods] = useState([]);
    const { loadTeacherperiods, getPeriodsDayTime, getPeriodsSubject, getAdditionalPeriodsWithTotals,
        saveTeacherperiods, getEmployeeList, getLocation, getStartDate, getEmployeeAdditionalInformation, isLoading } = useTimeSheets();
    const { rowAdd, rowEdit } = useTableHelper();
    const [changes, setChanges] = useState({})
    const [deletedItems, setDeletedItems] = useState([]);
    const [periodDayTime, setPeriodDayTime] = useState([]);
    const [additionalPeriods, setAdditionalPeriods] = useState([]);
    const [additionalPeriodsValue, setAdditionalPeriodsValue] = useState([]);
    const [duplicates, setDuplicates] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [employeesStartDate, setEmployeesStartDate] = useState([]);
    const ref = useRef(null);
    //#endregion

    //#region UseEffect
    useEffect(() => {
        setLoading(true);
        getPeriodsDayTime().then(dayTime => {
            setPeriodDayTime(dayTime)
            getPeriodsSubject().then(subject => {
                setSubjects(subject)
                getAdditionalPeriodsWithTotals().then((respAdditional) => {
                    let addPeriods = [];
                    respAdditional.map((addItr) => {
                        addPeriods.push({ id: addItr.additionalCode, name: addItr.additionalDesc })
                    })
                    setAdditionalPeriodsValue(respAdditional)
                    setAdditionalPeriods(addPeriods)
                    getEmployeeList(props.selectedItem).then(empl => {
                        setEmployees(empl.dropDownEmpl)
                        setEmployeesStartDate(empl.emplList)
                        loadTeacherperiods(props.selectedItem.timesheetUI)
                            .then(tp => {
                                // console.log('teacher periods', tp);
                                setTeacherPeriods(tp)
                                setChanges({});
                                setLoading(false);
                            })
                            .catch(error => {
                                console.error(error)
                            });
                    }).catch(emplError => {
                        console.log(emplError)
                    })
                }).catch(addError => {
                    console.log(addError)
                })
            }).catch(subjError => {
                console.log(subjError)
            })
        }).catch(periodsError => {
            console.log(periodsError)
        })
    }, [props.selectedItem])
    //#endregion

    //#region Helpers 
    const isMonthifStartDateWithinYear = (key, startDate, value) => {
        let retVal = value;
        // * Only m1-12 will contain startDate and that is what we are interested in. 
        if (startDate === '')
            return retVal;
        let schoolYearStart = new Date(`${props.selectedItem.yr - 1}-09-01`);
        let schoolYearEnd = new Date(`${props.selectedItem.yr}-05-31`);
        let convertedStartDate = new Date(changeDateFromDDMMYYYYtoYYYYMMDD(startDate));
        let convertedStartDateMonth = convertedStartDate ? convertedStartDate.getMonth() + 1 : null;
        let convertedStartDateYear = convertedStartDate ? convertedStartDate.getFullYear() + 1 : null;
        if (convertedStartDate >= schoolYearStart && convertedStartDate <= schoolYearEnd) {
            let checkDate;
            switch (key) {
                case 'm1':
                    checkDate = new Date(`${props.selectedItem.yr - 1}-09-01`);
                    if (convertedStartDateMonth > checkDate.getMonth() + 1 && convertedStartDateYear >= checkDate.getFullYear + 1)
                        retVal = 0;
                    break;
                case 'm2':
                    checkDate = new Date(`${props.selectedItem.yr - 1}-10-01`);
                    if (convertedStartDateMonth > checkDate.getMonth() + 1 && convertedStartDateYear >= checkDate.getFullYear + 1)
                        retVal = 0;
                    break;
                case 'm3':
                    checkDate = new Date(`${props.selectedItem.yr - 1}-11-01`);
                    if (convertedStartDateMonth > checkDate.getMonth() + 1 && convertedStartDateYear >= checkDate.getFullYear + 1)
                        retVal = 0;
                    break;
                case 'm4':
                    checkDate = new Date(`${props.selectedItem.yr - 1}-12-01`);
                    if (convertedStartDateMonth > checkDate.getMonth() + 1 && convertedStartDateYear >= checkDate.getFullYear + 1)
                        retVal = 0;
                    break;
                case 'm5':
                    checkDate = new Date(`${props.selectedItem.yr}-01-01`);
                    if (convertedStartDateMonth > checkDate.getMonth() + 1 && convertedStartDateYear >= checkDate.getFullYear + 1)
                        retVal = 0;
                    break;
                case 'm7':
                    checkDate = new Date(`${props.selectedItem.yr}-02-01`);
                    if (convertedStartDateMonth > checkDate.getMonth() + 1 && convertedStartDateYear >= checkDate.getFullYear + 1)
                        retVal = 0;
                    break;
                case 'm8':
                    checkDate = new Date(`${props.selectedItem.yr}-03-01`);
                    if (convertedStartDateMonth > checkDate.getMonth() + 1 && convertedStartDateYear >= checkDate.getFullYear + 1)
                        retVal = 0;
                    break;
                case 'm9':
                    checkDate = new Date(`${props.selectedItem.yr}-04-01`);
                    if (convertedStartDateMonth > checkDate.getMonth() + 1 && convertedStartDateYear >= checkDate.getFullYear + 1)
                        retVal = 0;
                    break;
                case 'm10':
                    checkDate = new Date(`${props.selectedItem.yr}-05-01`);
                    if (convertedStartDateMonth > checkDate.getMonth() + 1 && convertedStartDateYear >= checkDate.getFullYear + 1)
                        retVal = 0;
                    break;
                case 'm11':
                    checkDate = new Date(`${props.selectedItem.yr}-06-01`);
                    if (convertedStartDateMonth > checkDate.getMonth() + 1 && convertedStartDateYear >= checkDate.getFullYear + 1)
                        retVal = 0;
                    break;
                case 'm12':
                    checkDate = new Date(`${props.selectedItem.yr}-07-01`);
                    if (convertedStartDateMonth > checkDate.getMonth() + 1 && convertedStartDateYear >= checkDate.getFullYear + 1)
                        retVal = 0;
                    break;
                default:
                    retVal = value
            }
        }
        return retVal.toString();
    }
    //#endregion 

    //#region Listener
    const setVal = (index, item, key, value, startDate = '', exceptions = ['ui', 'approved', 'employeeID', 'name', 'location', 'subject', 'yr', 'approved',
        'delete', 'ptshdt', 'compDesc', 'comments', 'startDate', 'm11', 'm12', 'mAverage', 'oAverage', 'additionalCode',
        'emplNumber', 'passNumber', 'jobTitle', '', 'seniority', 'employmentContext', 'emplContextDesc', 'mAverage', 'unitConvert', 'endDate', 'branch',
        'residencePermitNumber']) => {
        // * Check key and startdate to switch value to zero 
        let verifiedValue = isMonthifStartDateWithinYear(key, startDate, value)
        const keys = ['m2', 'm3', 'm4', 'm5', 'm6', 'm7', 'm8', 'm9', 'm10', 'm11', 'm12'];
        // * Change the rest if 0 to the same as the first one. 
        if (key === 'm1' && (teacherPeriods[index][key] >= 0 && teacherPeriods[index][key] < 10)) {
            let tempPrds = [...teacherPeriods]
            for (let keyItr in tempPrds[index]) {
                if (!exceptions.includes(keyItr) && (tempPrds[index][keyItr] >= 0 || tempPrds[index][keyItr] < 10)) {
                    tempPrds[index][keyItr] = isNaN(parseInt(verifiedValue)) ? 0 : parseInt(verifiedValue)
                    rowEdit(index, item, keyItr, parseInt(verifiedValue), changes, setChanges, tempPrds, setTeacherPeriods)
                }
            }
        }
        else if (keys.includes(key)) {
            if (exceptions.includes(key)) return;
            rowEdit(index, item, key, isNaN(parseInt(verifiedValue)) ? 0 : parseInt(verifiedValue), changes, setChanges, teacherPeriods, setTeacherPeriods)
        }
        else {
            rowEdit(index, item, key, verifiedValue, changes, setChanges, teacherPeriods, setTeacherPeriods)
        }
    }
    const setEmployeeVal = (index, item, key, value) => {
        // * Check if value is empty and do nothing 
        if (value === '')
            return
        let tempPrds = [...teacherPeriods]
        tempPrds[index].employeeID = value;
        getLocation(value).then(loc => {
            tempPrds[index].location = loc;
            getStartDate(value).then(startDate => {
                tempPrds[index].startDate = startDate;
                tempPrds[index].timesheetUI = props.selectedItem.timesheetUI;
                getEmployeeAdditionalInformation(value, props.selectedItem.company).then((empldata) => {
                    tempPrds[index].emplNumber = empldata.emplNumber === '' ? empldata.passNumber : empldata.emplNumber;
                    tempPrds[index].passNumber = empldata.passNumber;
                    tempPrds[index].jobTitle = empldata.jobTitle;
                    tempPrds[index].seniority = empldata.seniority;
                    tempPrds[index].employmentContext = empldata.employmentContext;
                    tempPrds[index].actualStartDate = empldata.actualStartDate;
                    rowEdit(index, item, key, value, changes, setChanges, tempPrds, setTeacherPeriods);
                }).catch(additionalError => {
                    console.log(additionalError)
                })
            }).catch(startDError => {
                console.log(startDError)
            })
        }).catch(locError => {
            console.log(locError)
        })
    }

    // Will add all the active employees 
    const addAllActiveEmployees = () => {
        let tP = []

        Swal.fire({
            title: 'Enter a number',
            title: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:defNum')}</text>`,
            input: 'number',
            icon: "warning",
            inputAttributes: {
                min: 0,
                step: 1
            },
            showCancelButton: true,
            cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:cancel')}</text>`,
            cancelButtonColor: '#d3d3d3',
            confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:confirmMessage')}</text>`,
            confirmButtonColor: '#A0A2FF',
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    if (value) {
                        resolve();
                    } else {
                        resolve('You need to enter a number');
                    }
                });
            }
        }).then((result) => {
            if (result.isConfirmed) {
                let changesCount = 0;
                let tempChanges = {};
                employeesStartDate.map((empl, index) => {
                    periodDayTime.map((pDItr) => {
                        if (pDItr.value === 'AM') {
                            let attr = [];
                            let boolAttr = ['delete'];
                            let intAttr = ['m1', 'm2', 'm3', 'm4', 'm5', 'm6', 'm7', 'm8', 'm9', 'm10', 'm11', 'm12', 'other1',
                                'other2', 'other3', 'other4', 'other5', 'other6', 'other7', 'other8', 'other9', 'other10', 'other11', 'other12'];

                            let newItem = {};
                            for (let key in teacherPeriods[0]) {
                                // * Company is the same for everything and will be ignored in areAllAttributesNullOrEmpty as well
                                if (attr.map(item => item.toLowerCase()).includes(key.toLowerCase())) {
                                    newItem[key] = teacherPeriods[0][key]
                                }
                                else if (teacherPeriods[0].hasOwnProperty(key))
                                    newItem[key] = ''

                                if (boolAttr.map(item => item.toLowerCase()).includes(key.toLowerCase())) {
                                    newItem[key] = false
                                }

                                if (intAttr.map(item => item.toLowerCase()).includes(key.toLowerCase())) {
                                    newItem[key] = isMonthifStartDateWithinYear(key, empl.startDate, result.value)
                                }
                            }

                            newItem.employeeID = empl.employeeId
                            newItem.startDate = empl.startDate
                            newItem.ptshdt = pDItr.value
                            newItem.mAverage = 0;
                            newItem.oAverage = 0;
                            // * Preselect No additional period for all employees
                            newItem.additionalCode = ['NO']
                            newItem.timesheetUI = props.selectedItem.timesheetUI
                            let c = { [changesCount]: { ...newItem } }
                            changesCount += 1;
                            tempChanges = { ...tempChanges, ...c }
                            tP.push(newItem)
                        }
                    })
                })
                setChanges(tempChanges)
                setTeacherPeriods(tP);
            } else if (result.isDismissed) {
                console.log('Cancelled');
                // Do nothing on cancel
            }
        });



    }

    // Remove Current Item. 
    const removeTimesheetLine = (index, item, key = 'delete', value = true) => {
        let tempPrds = [...teacherPeriods]
        tempPrds[index].delete = true;
        rowEdit(index, item, key, value, changes, setChanges, tempPrds, setTeacherPeriods)
    }

    const validation = () => {
        const keys = Object.keys(changes);
        let ret = [true, 0]
        keys.forEach(key => {
            const nestedObject = changes[key];
            if (nestedObject.ptshdt === "")
                ret = [false, key]
        });
        return ret;
    }

    // * SAVE 
    const save = () => {
        if (Object.keys(changes).length === 0) {
            showMessage({
                message: t('common:noChangesToSave'),
                type: "success",
                duration: 3000,
            });
            return;
        }
        // * Check if empty ptshdt / time of day - only this field is valid for this rest can be empty 
        let valid = validation();
        if (!valid[0]) {
            showMessage({
                message: t('common:missingptsdh'),
                type: "danger",
                duration: 3000,
            });
            //TODO set the value to highlight the wrong entry
            return;
        }
        saveTeacherperiods(changes)
            .then((resp) => {
                // * if save is successul then refresh data to get UI 
                // * of the first entry 
                if (resp) {
                    loadTeacherperiods(props.selectedItem.timesheetUI)
                        .then(tp => {
                            setTeacherPeriods(tp)
                            setChanges({});
                            setDeletedItems({})
                            showMessage({
                                message: t('common:teacherPeriodsSucc'),
                                type: "success",
                                duration: 3000,
                            });
                        })
                        .catch(error => {
                            console.error(error)
                        });
                }
            })
            .catch(error => {
                console.error(error)
                showMessage({
                    message: t('common:teacherPeriodsfail'),
                    type: "danger",
                    duration: 3000,
                });
            });

    }

    //#endregion
    const renderCard = useCallback((item, index) => {
        // Soft delete line by not rendering it only if it is saved it is permanetly deleted. 
        if (item.delete === true)
            return (<></>)

        let branch = !props?.branch ? item?.branch : props?.branch;
        let location = !props?.location ? item?.location : props?.location;
        let obj = { ...item, ['branch']: branch, ['location']: location };
        let school = props.getOfficialSchoolName(obj, { employmentContext: item?.employmentContext });
        item.school = school?.secondarySchool ? `${school.secondarySchool}\n&\n${school.title}` : school?.title;


        return (<Card
            style={common.cardstyle}
            key={index}>
            <Card.Content>
                <FlatListView
                    item={item} index={index}
                    props={props}
                    styles={styles}
                    setVal={setVal}
                    employees={employees}
                    setEmployeeVal={setEmployeeVal}
                    duplicates={duplicates}
                    periodDayTime={periodDayTime}
                    additionalPeriods={additionalPeriods}
                    additionalPeriodsValue={additionalPeriodsValue}
                    removeTimesheetLine={removeTimesheetLine}
                    t={t} />
            </Card.Content>
        </Card>
        )
    }, [teacherPeriods, setTeacherPeriods, duplicates, employees, periodDayTime]);

    if (loading) {
        return (
            <SafeAreaView
                style={styles.mainView}>
                <ActivityIndicator animating={true} size='large' color="#86BC25" />
            </SafeAreaView>
        )
    }
    return (
        <SafeAreaView
            style={styles.mainView}>
            <FlatList
                data={teacherPeriods}
                renderItem={({ item, index }) =>
                    renderCard(item, index)
                }
                // TODO
                // onRefresh={() => props.loadEverySurvey()}
                scrollEnabled={true}
                extraData={true}
                refreshing={loading}
                keyExtractor={(item, index) => `${item.employeeID}-${index}`}
                ListEmptyComponent={
                    (isLoading && employees.length == 0) &&
                    <SafeAreaView
                        style={styles.mainView}>
                        <ActivityIndicator animating={true} size='large' color="#86BC25" />
                    </SafeAreaView>
                }
                ListHeaderComponent={
                    <>
                        {!props.selectedItem.submitted &&
                            <SafeAreaView style={common.listTitle}>
                                <CustomLabel
                                    value={'Location: ' + props.selectedLocation}
                                    type='MINORTITLE' />
                                <SafeAreaView
                                    style={styles.rowMargin}>
                                    <CustomButton
                                        onPress={() => {
                                            rowAdd(teacherPeriods, setTeacherPeriods, ['delete', 'm1', 'm2', 'm3', 'm4', 'm5', 'm6', 'm7', 'm8', 'm9', 'm10', 'm11', 'm12', 'mAverage', 'oAverage', 'timesheetUI'],
                                                ['delete'], ref, t, ['timesheetUI'],
                                                ['m1', 'm2', 'm3', 'm4', 'm5', 'm6', 'm7', 'm8', 'm9', 'm10', 'm11', 'm12', 'mAverage', 'oAverage'], changes, setChanges)
                                        }}
                                        text={t('navigate:newEmployee')}
                                        iconName='add-outline'
                                        show='BUTTON_ADD'
                                        type='BUTTON_ADD'
                                        textTop='0'
                                        sz={15}
                                    />
                                    <CustomButton
                                        onPress={() => {
                                            addAllActiveEmployees()
                                        }}
                                        text={t('common:addAll')}
                                        iconName='person-add-outline'
                                        show='BUTTON_ADD'
                                        type='BUTTON_ADD'
                                        textTop='0'
                                        sz={15}
                                    />
                                    {(Object.keys(changes).length > 0 || deletedItems.length > 0) &&
                                        <CustomButton
                                            onPress={() => {
                                                save()
                                            }}
                                            text={t('common:save')}
                                            iconName='save-outline'
                                            show='BUTTON_SAVE'
                                            type='BUTTON_SAVE'
                                            isGradient={true}
                                            textTop='0'
                                            sz={15}
                                        />
                                    }
                                    <CustomButton
                                        onPress={() => {
                                            props.toggleSubmit(props.selectedItem.timesheetUI)
                                        }}
                                        text={t('common:submit')}
                                        iconName='send-outline'
                                        show='BUTTON_SAVE'
                                        type='BUTTON_SAVE'
                                        isGradient={true}
                                        textTop='0'
                                        sz={15}
                                    />
                                    <CustomButton
                                        onPress={() => {
                                            props.downloadExcel(teacherPeriods)
                                        }}
                                        iconName='download-outline'
                                        show='BUTTON_ADD'
                                        type='BUTTON_ADD'
                                        textTop='0'
                                        sz={15}
                                    />
                                </SafeAreaView>
                            </SafeAreaView>
                        }
                    </>
                }

                initialNumToRender={4}
            />
        </SafeAreaView >
    )
}



const makeStyles = (colors, height, width) => StyleSheet.create({
    mainView: {
        height: (Platform.OS === 'web' ? height * 60 / 100 : '95%'),
        flex: 1,
        justifyContent: 'center'
    },
    item: {
        flex: 1,
        // padding: 100,
    },
    detailsRowComments: {
        flex: 1,
        flexDirection: 'row'
    },
    detailsRowHours: {
        flex: 2,
        flexDirection: 'row'
    },
    details: {
        flex: 1,
    },
    modalCheckBoxRow: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    rowMargin: {
        flex: 1,
        flexDirection: "row",
        justifyContent: 'flex-end',
        marginRight: 15,
    },
    row: {
        // flex: 1,
        flexDirection: "row",
    },
    rowMonths: {
        flex: 1,
        flexDirection: "row",
        marginVertical: 10,
    },
    averageRow: {
        flex: 1,
        marginTop: 10,
        marginBottom: 5,
        flexDirection: 'row',
    },
    average: {
        flex: 1,
        borderBottomColor: 'transparent',
        borderBottomWidth: StyleSheet.hairlineWidth,
        justifyContent: 'center',
        marginVertical: 10,
    },
    row25: {
        flex: 1,
        flexDirection: "row",
        marginBottom: 10,
    },
    row75: {
        flex: 3,
        flexDirection: "row",
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    rowNoflex: {
        flexDirection: "row",
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    button: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: "center",
        alignItems: "center",
    },
    line: {
        borderBottomColor: colors.buttons_primary,
        borderBottomWidth: StyleSheet.hairlineWidth,
        marginTop: (Platform.OS === 'web' && width > 1300) ? 10 : 20,
        marginBottom: (Platform.OS === 'web' && width > 1300) ? 10 : 20,
    },
    lineInvisible: {
        borderBottomColor: 'transparent',
        borderBottomWidth: StyleSheet.hairlineWidth,
        marginTop: (Platform.OS === 'web' && width > 1300) ? 10 : 20,
        marginBottom: (Platform.OS === 'web' && width > 1300) ? 10 : 20,
    },
    split: {
        margin: 5,
    },
    months: {
        flex: 1,
        borderBottomColor: 'transparent',
        borderBottomWidth: StyleSheet.hairlineWidth,
        justifyContent: 'center',
    },
    comments: {
        flex: 5,
        justifyContent: 'center',
        marginHorizontal: 10,
    },
})

export default TeacherPeriods;

